import { Navigate, Route, Routes } from "react-router-dom";
import { ThemeProvider } from "@mui/material";
import LoginPage from "./features/property-setup/pages/LoginPage";
import UnauthorizedPage from "./features/property-setup/pages/UnauthorizedPage";
import MenuPage from "./features/property-setup/pages/MenuPage";
import SelectPropertyPage from "./features/property-setup/pages/SelectPropertyPage";
import SetupNewPage, {
  SetupEditPage,
} from "./features/property-setup/pages/SetupPages";
import { AuthProvider, useAuth } from "./features/property-setup/routing/AuthContext";
import RequireAuth from "./features/property-setup/routing/RequireAuth";
import { ROUTES } from "./features/property-setup/routing/paths";
import { theme } from "./features/property-setup/theme";
import "./App.css";

function LoginRoute() {
  const { isAuthenticated, properties } = useAuth();

  if (isAuthenticated) {
    return (
      <Navigate
        to={properties.length > 0 ? ROUTES.menu : ROUTES.setupNew}
        replace
      />
    );
  }

  return <LoginPage />;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path={ROUTES.login} element={<LoginRoute />} />
      <Route path={ROUTES.unauthorized} element={<UnauthorizedPage />} />

      <Route element={<RequireAuth />}>
        <Route path={ROUTES.menu} element={<MenuPage />} />
        <Route path={ROUTES.selectProperty} element={<SelectPropertyPage />} />
        <Route path={ROUTES.setupNew} element={<SetupNewPage />} />
        <Route path="/setup/editar/:documentId" element={<SetupEditPage />} />
      </Route>

      <Route path="/" element={<Navigate to={ROUTES.login} replace />} />
      <Route path="*" element={<Navigate to={ROUTES.login} replace />} />
    </Routes>
  );
}

function App() {
  return (
    <ThemeProvider theme={theme}>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
